var _path;
const _excluded = ["title", "titleId"],
  _excluded2 = ["title", "titleId"],
  _excluded3 = ["className", "color", "size", "pointer"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef, memo } from "react";
import { hooks } from '@approvalmax/utils';
const SVG = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#A0A1A1",
    fillRule: "evenodd",
    d: "m13.225 13.754 4.581 4.581a.967.967 0 0 1-.007 1.371.97.97 0 0 1-1.37.007l-4.756-4.755a7.6 7.6 0 0 1-3.88 1.062C3.49 16.02 0 12.434 0 8.01S3.49 0 7.794 0s7.793 3.586 7.793 8.01a8.1 8.1 0 0 1-2.362 5.744m-5.431.263c3.228 0 5.845-2.69 5.845-6.007 0-3.318-2.617-6.008-5.845-6.008-3.229 0-5.846 2.69-5.846 6.008s2.617 6.007 5.846 6.007"
  })));
});
const SvgTbSearchGreyIcon = (_ref2, ref) => {
  let {
      title,
      titleId
    } = _ref2,
    props = _objectWithoutProperties(_ref2, _excluded2);
  const {
      className = '',
      color,
      size,
      pointer
    } = props,
    restProps = _objectWithoutProperties(props, _excluded3);
  const isClient = hooks.useOnlyClientRendering();
  const colorClassNameMod = color ? 'am-icon_color-' + color : '';
  const sizeClassNameMod = size ? 'am-icon_size-' + size : '';
  const poinerClassNameMod = pointer ? 'am-icon_pointer' : '';
  const classNames = [className, 'am-icon', colorClassNameMod, sizeClassNameMod, poinerClassNameMod].join(' ');
  if (!isClient) return null;
  return /*#__PURE__*/React.createElement(SVG, _extends({
    className: classNames
  }, restProps));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgTbSearchGreyIcon);
const Memo = /*#__PURE__*/memo(ForwardRef);
export { Memo as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTkiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAxOSAyMCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48dGl0bGU+NjZEMjQxOUUtQUU1MC00QzIwLUE1MTItQzBFNUQ0QkMxOTgyPC90aXRsZT48cGF0aCBkPSJNMTMuMjI1IDEzLjc1NGw0LjU4MSA0LjU4MWEuOTY3Ljk2NyAwIDAgMS0uMDA3IDEuMzcxLjk3MS45NzEgMCAwIDEtMS4zNy4wMDdsLTQuNzU2LTQuNzU1YTcuNTk3IDcuNTk3IDAgMCAxLTMuODggMS4wNjJDMy40OSAxNi4wMiAwIDEyLjQzNCAwIDguMDEgMCAzLjU4NiAzLjQ5IDAgNy43OTQgMGM0LjMwNCAwIDcuNzkzIDMuNTg2IDcuNzkzIDguMDEgMCAyLjI1My0uOTA1IDQuMjg5LTIuMzYyIDUuNzQ0em0tNS40MzEuMjYzYzMuMjI4IDAgNS44NDUtMi42OSA1Ljg0NS02LjAwNyAwLTMuMzE4LTIuNjE3LTYuMDA4LTUuODQ1LTYuMDA4LTMuMjI5IDAtNS44NDYgMi42OS01Ljg0NiA2LjAwOHMyLjYxNyA2LjAwNyA1Ljg0NiA2LjAwN3oiIGZpbGw9IiNBMEExQTEiIGZpbGwtcnVsZT0iZXZlbm9kZCIvPjwvc3ZnPg==";